module.exports = __webpack_public_path__ + "img/Ellipse-298.ea2e391e.svg";